var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSmallWarning = function SvgSmallWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.973v3.333M8 15.246H3.96c-2.313 0-3.28-1.653-2.16-3.673l2.08-3.747 1.96-3.52c1.187-2.14 3.133-2.14 4.32 0l1.96 3.527 2.08 3.746c1.12 2.02.147 3.674-2.16 3.674H8v-.007Z",
    stroke: "#A4AAB0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.996 12.306h.006",
    stroke: "#A4AAB0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgSmallWarning;